// extracted by mini-css-extract-plugin
module.exports = {"main":"Page404_main__2PLo0"};